import { useState } from "react";
import { useAccount } from "./useAccount";
import { Avviso, Bottone, Campo, LinkTesto, PaginaAccount, Scheda } from "./ui";
import { C } from "../theme/tokens";

/** Senza token: chiede l'email. Con token (dal link): chiede la nuova password. */
export default function PasswordPage({ onNavigate, token }) {
  const { api } = useAccount();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [conferma, setConferma] = useState("");
  const [errore, setErrore] = useState(null);
  const [esito, setEsito] = useState(null);
  const [inCorso, setInCorso] = useState(false);

  const richiedi = async (e) => {
    e.preventDefault();
    setInCorso(true); setErrore(null);
    try {
      const r = await api.richiediReset(email);
      setEsito(r.messaggio || "Controlla la posta.");
    } catch (err) {
      setErrore(err.message);
    } finally {
      setInCorso(false);
    }
  };

  const reimposta = async (e) => {
    e.preventDefault();
    if (password !== conferma) { setErrore("Le due password non coincidono."); return; }
    setInCorso(true); setErrore(null);
    try {
      const r = await api.reimpostaPassword(token, password);
      setEsito(r.messaggio || "Password aggiornata.");
    } catch (err) {
      setErrore(err.message);
    } finally {
      setInCorso(false);
    }
  };

  if (token) {
    return (
      <PaginaAccount titolo="Nuova password" onBack={() => onNavigate("accesso")} etichettaBack="Accesso">
        <Scheda>
          {esito ? (
            <>
              <Avviso tipo="ok">{esito}</Avviso>
              <Bottone onClick={() => onNavigate("accesso")}>Vai all&apos;accesso</Bottone>
            </>
          ) : (
            <form onSubmit={reimposta}>
              <Campo etichetta="Nuova password" tipo="password" valore={password} onChange={setPassword} autoComplete="new-password" minLength={10} aiuto="Almeno 10 caratteri." />
              <Campo etichetta="Ripeti la password" tipo="password" valore={conferma} onChange={setConferma} autoComplete="new-password" minLength={10} />
              {errore && <Avviso tipo="errore">{errore}</Avviso>}
              <Bottone tipo="submit" pieno disabilitato={inCorso}>{inCorso ? "Salvataggio..." : "Salva la nuova password"}</Bottone>
            </form>
          )}
        </Scheda>
      </PaginaAccount>
    );
  }

  return (
    <PaginaAccount titolo="Recupero password" sottotitolo="Ti mandiamo un link per scegliere una nuova password. Vale un'ora." onBack={() => onNavigate("accesso")} etichettaBack="Accesso">
      <Scheda>
        {esito ? <Avviso tipo="ok">{esito}</Avviso> : (
          <form onSubmit={richiedi}>
            <Campo etichetta="Email" tipo="email" valore={email} onChange={setEmail} autoComplete="email" />
            {errore && <Avviso tipo="errore">{errore}</Avviso>}
            <Bottone tipo="submit" pieno disabilitato={inCorso}>{inCorso ? "Invio..." : "Inviami il link"}</Bottone>
          </form>
        )}
      </Scheda>
      <p style={{ fontSize: 13, color: C.textNum, textAlign: "center", margin: 0 }}>
        <LinkTesto onClick={() => onNavigate("accesso")}>Torna all&apos;accesso</LinkTesto>
      </p>
    </PaginaAccount>
  );
}
